import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { AuthService } from '../components/auth.servicice';

@Injectable({
  providedIn: 'root'
})
export class Sit2Service {

  constructor(private http: HttpClient, private authService: AuthService) { }

  cifrarIdXBarcode(idSoporte: any): Observable<any> {
    const config = this.authService.getValueConfig();
    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json')
    const httpOptions = { headers: authHeaders };
    let url = config.urlCifrarIdXBarcode;
    if (environment.production == false && environment.proxyOfinaVirtual != null) {
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    return this.http.get(`${url}${idSoporte}`, httpOptions);
  }

  getMisAct(): Observable<any> {
    const user = this.authService.getValueUser();
    const config = this.authService.getValueConfig();
    const data = { vigencia: "10", objeto: user.nroId, idObjeto: user.tipoId };
    let params = new HttpParams();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        params = params.set(key, (data as any)[key]);
      }
    }
    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json')
    const httpOptions = { headers: authHeaders, params: params };
    let url = config.urlActividad;
    if (environment.production == false && environment.proxyOfinaVirtual != null) {
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    if (url.endsWith("_123")) {
      url = url.slice(0, -4);
    } else if (url.endsWith("_xxx")) {
      url = url.slice(0, -4);
    }
    return this.http.post(`${url}`, data, httpOptions);
  }
}
